module.exports = __webpack_public_path__ + "static/media/iconfinder_ic_local_grocery_store_48px_352500.c22f03a9.svg";